import randomIdGenerator from "utilities/random_id_generator";

export default class ElevationPositionMarker {
  defaultMarkerOptions = {
    "paint": {
      "circle-radius": 6,
      "circle-color": "black",
      "circle-opacity": 0.7,
      "circle-stroke-width": 2,
      "circle-stroke-color": "#fff",
      "circle-pitch-alignment": "map"
    }
  };

  constructor(pointFeature, map) {
    this.map = map;
    this.id = randomIdGenerator();
    this.map.addSource(`elevation-position-marker-source-${this.id}`, {
      'type': 'geojson',
      'data': pointFeature
    });
  }

  show() {
    if (this.map.getLayer(`elevation-position-marker-layer-${this.id}`)) return;

    this.map.addLayer({
      'id': `elevation-position-marker-layer-${this.id}`,
      'type': 'circle',
      'source': `elevation-position-marker-source-${this.id}`,
      ...this.defaultMarkerOptions
    });
  }

  hide() {
    if (this.map.getLayer(`elevation-position-marker-layer-${this.id}`))
      this.map.removeLayer(`elevation-position-marker-layer-${this.id}`);
  }

  setPosition(pointFeature) {
    this.map
        .getSource(`elevation-position-marker-source-${this.id}`)
        .setData(pointFeature);
  }
}
